import React from 'react'
import { Text } from '@/components/atoms/Text'
import { CategoryChip } from '@/components/atoms/CategoryChip'
import './BrandCard.css'

export interface BrandCardProps {
  name: string
  category: string
  logoUrl?: string
  logoAlt?: string
  className?: string
}

export const BrandCard: React.FC<BrandCardProps> = ({
  name,
  category,
  logoUrl,
  logoAlt = `${name} logo`,
  className = '',
}) => {
  return (
    <div className={`brand-card ${className}`}>
      <div className="brand-card-logo">
        {logoUrl ? (
          <img src={logoUrl} alt={logoAlt} className="brand-card-logo-image" />
        ) : (
          <div className="brand-card-logo-placeholder">
            <span className="brand-card-logo-placeholder-text">{name.charAt(0)}</span>
          </div>
        )}
      </div>
      <div className="brand-card-content">
        <Text size="large" color="primary" weight="normal" className="brand-card-name">
          {name}
        </Text>
        <CategoryChip label={category} />
      </div>
    </div>
  )
}
